// utils/tableColumnNamesCOI.js
export const tableColumnNamesCOI = {
  Candidate: 'candidateName',
  Committee: 'sectionalCommitteeId',
  Member: 'memberName',
  'COI Status': 'statusName',
  'Conflict Type': 'coiCategory',
  'Conflict subtype': 'coiTypes',
  Detail: 'coiDetail',

  'Created at': 'createdAt',
  'Updated at': 'updatedAt',
  'Published at': 'publishedAt',
};
